export function imageUrl(id) {
  return `https://drive.google.com/uc?id=${id}&export=download`;
}

export function thumbUrl(id, size) {
  return `https://drive.google.com/thumbnail?authuser=0&sz=w${size}&id=${id}`;
}
